import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class ProductEventService {
    private sessionRequestStarted = false;

    constructor(private http: HttpClient) { }

    recordSession(): void {
        if (this.sessionRequestStarted) {
            return;
        }

        this.sessionRequestStarted = true;
        this.http.post<void>(`${environment.searchApiUrl}/events/session`, null)
            .subscribe({
                error: () => {
                    this.sessionRequestStarted = false;
                }
            });
    }
}
